import ReactQuill from "react-quill";
import quillEmoji from "quill-emoji";

const { EmojiBlot, ShortNameEmoji, ToolbarEmoji, TextAreaEmoji } = quillEmoji;

export default function RichTextInput({
  value,
  onChange,
  modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ color: [] }, { background: [] }],
      ["bold", "italic", "underline", "background"],
      ["strike", "blockquote", "code-block"],
      [{ align: [] }],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["emoji"],
    ],
    "emoji-toolbar": true,
    "emoji-textarea": true,
    "emoji-shortname": true,
  },
  formats = [
    "color",
    "header",
    "align",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "code-block",
    "background",
    "list",
    "indent",
    "bullet",
    "link",
    "image",
    "emoji",
  ],
  ...rest
}) {
  return (
    <ReactQuill
      defaultValue={""}
      value={value}
      onChange={onChange}
      formats={formats}
      modules={modules}
      {...rest}
    />
  );
}
